import React from 'react';
import './WhatsAppButton.css';

const WHATSAPP_LINK = 'https://wa.me/919929988684';

const WhatsAppButton = () => {
  return (
    <a
      className="whatsapp-button"
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <svg
        className="whatsapp-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
      >
        <path
          fill="currentColor"
          d="M19.11 17.41c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.18-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.13-.13.27-.34.41-.52.14-.18.18-.3.27-.5.09-.2.05-.37-.02-.52-.07-.14-.61-1.48-.84-2.03-.22-.53-.45-.46-.61-.47h-.52c-.18 0-.47.07-.72.34-.25.27-.95.93-.95 2.27s.97 2.64 1.11 2.82c.14.18 1.91 2.91 4.63 4.08.65.28 1.15.45 1.55.57.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.82-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32z"
        />
        <path
          fill="currentColor"
          d="M16 3C8.82 3 3 8.82 3 16c0 2.53.74 4.89 2.01 6.88L3 29l6.27-1.64A12.93 12.93 0 0016 29c7.18 0 13-5.82 13-13S23.18 3 16 3zm0 23.6c-2.07 0-4.09-.56-5.86-1.61l-.42-.25-3.72.97.99-3.63-.27-.44A10.6 10.6 0 015.4 16c0-5.85 4.75-10.6 10.6-10.6S26.6 10.15 26.6 16 21.85 26.6 16 26.6z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
